import React from "react";

const OUTER_PADDING = 16;

const styles = {
    shell: {
        position: "relative",
        width: "100%",
        height: `calc(100dvh - var(--playground-page-offset, 0px) - ${OUTER_PADDING * 2}px)`,
        minWidth: 0,
        minHeight: 0,
        boxSizing: "border-box",
        overflow: "hidden",
        borderRadius: "22px",
        background:
            "radial-gradient(circle at top, rgba(92, 18, 18, 0.22), transparent 36%), linear-gradient(180deg, rgba(8, 9, 14, 0.98), rgba(4, 4, 8, 1))",
        boxShadow:
            "0 28px 80px rgba(0, 0, 0, 0.55), inset 0 1px 0 rgba(255, 255, 255, 0.04)",
        isolation: "isolate",
    },
    backdropNoise: {
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        background:
            "radial-gradient(circle at 15% 18%, rgba(255, 255, 255, 0.03), transparent 18%), radial-gradient(circle at 82% 16%, rgba(255, 255, 255, 0.02), transparent 18%), radial-gradient(circle at 40% 78%, rgba(255, 255, 255, 0.02), transparent 22%)",
        opacity: 0.75,
    },
    overlayTopLeft: {
        position: "absolute",
        top: "16px",
        left: "16px",
        zIndex: 5,
        pointerEvents: "auto",
        maxWidth: "min(42vw, 560px)",
    },
    overlayTopRight: {
        position: "absolute",
        top: "16px",
        right: "16px",
        zIndex: 5,
        pointerEvents: "auto",
        maxHeight: "calc(100% - 32px)",
        overflow: "hidden",
    },
    overlayBottomLeft: {
        position: "absolute",
        bottom: "16px",
        left: "16px",
        zIndex: 5,
        pointerEvents: "auto",
        maxHeight: "calc(100% - 32px)",
        overflow: "hidden",
    },
    overlayBottomRight: {
        position: "absolute",
        bottom: "16px",
        right: "16px",
        zIndex: 5,
        pointerEvents: "auto",
        maxHeight: "calc(100% - 32px)",
        overflow: "hidden",
    },
    canvasRegion: {
        position: "absolute",
        inset: 0,
        minWidth: 0,
        minHeight: 0,
        overflow: "hidden",
    },
};

const overlayStyleMap = {
    "top-left": styles.overlayTopLeft,
    "top-right": styles.overlayTopRight,
    "bottom-left": styles.overlayBottomLeft,
    "bottom-right": styles.overlayBottomRight,
};

function renderOverlaySlot(position, node) {
    if (!node) {
        return null;
    }

    return (
        <div key={position} style={overlayStyleMap[position]}>
            {node}
        </div>
    );
}

export default function RhythmStageShell({ overlaySlots = null, children }) {
    return (
        <div
            style={styles.shell}
            role="presentation"
        >
            <div style={styles.backdropNoise} />

            {overlaySlots
                ? Object.entries(overlaySlots).map(([position, node]) =>
                    renderOverlaySlot(position, node)
                )
                : null}

            <div style={styles.canvasRegion}>{children}</div>
        </div>
    );
}